export function formatDimensions(height: number, width: number): string {
  return `${height}x${width}`;
}
